module.exports = function (c) {
  return {
    computeTangents: function (j) {
      function q(ai, aj, ak) {
        X.fromArray(H, ai * 3);
        Y.fromArray(H, aj * 3);
        Z.fromArray(H, ak * 3);
        a0.fromArray(K, ai * 2);
        a1.fromArray(K, aj * 2);
        a2.fromArray(K, ak * 2);
        Y.sub(X);
        Z.sub(X);
        a1.sub(a0);
        a2.sub(a0);
        var al = 1 / (a1.x * a2.y - a2.x * a1.y);
        if (isFinite(al)) {
          a3.copy(Y)
            .multiplyScalar(a2.y)
            .addScaledVector(Z, -a1.y)
            .multiplyScalar(al);
          a4.copy(Z)
            .multiplyScalar(a1.x)
            .addScaledVector(Y, -a2.x)
            .multiplyScalar(al);
          U[ai].add(a3);
          U[aj].add(a3);
          U[ak].add(a3);
          V[ai].add(a4);
          V[aj].add(a4);
          V[ak].add(a4);
        }
      }
      function z(ai) {
        ae.fromArray(J, ai * 3);
        af.copy(ae);
        aa = U[ai];
        ac.copy(aa);
        ac.sub(ae.multiplyScalar(ae.dot(aa))).normalize();
        ad.crossVectors(af, aa);
        ab = ad.dot(V[ai]);
        a9 = ab < 0 ? -1 : 1;
        Q[ai * 4] = ac.x;
        Q[ai * 4 + 1] = ac.y;
        Q[ai * 4 + 2] = ac.z;
        Q[ai * 4 + 3] = a9;
      }
      var B = j.index;
      var F = j.attributes;
      if (
        B !== null &&
        F.position !== undefined &&
        F.normal !== undefined &&
        F.uv !== undefined
      ) {
        var G = B.array;
        var H = F.position.array;
        var J = F.normal.array;
        var K = F.uv.array;
        var N = H.length / 3;
        if (F.tangent === undefined) {
          j.setAttribute(
            "tangent",
            new c.BufferAttribute(new Float32Array(N * 4), 4),
          );
        }
        var Q = F.tangent.array;
        var U = [];
        var V = [];
        for (var W = 0; W < N; W++) {
          U[W] = new c.Vector3();
          V[W] = new c.Vector3();
        }
        var X = new c.Vector3();
        var Y = new c.Vector3();
        var Z = new c.Vector3();
        var a0 = new c.Vector2();
        var a1 = new c.Vector2();
        var a2 = new c.Vector2();
        var a3 = new c.Vector3();
        var a4 = new c.Vector3();
        var a5 = j.groups;
        if (a5.length === 0) {
          a5 = [
            {
              start: 0,
              count: G.length,
            },
          ];
        }
        W = 0;
        for (var a6 = a5.length; W < a6; ++W) {
          for (
            var a7 = (ah = (ag = a5[W]).start), a8 = ah + ag.count;
            a7 < a8;
            a7 += 3
          ) {
            q(G[a7 + 0], G[a7 + 1], G[a7 + 2]);
          }
        }
        var a9;
        var aa;
        var ab;
        var ac = new c.Vector3();
        var ad = new c.Vector3();
        var ae = new c.Vector3();
        var af = new c.Vector3();
        W = 0;
        a6 = a5.length;
        for (; W < a6; ++W) {
          var ag;
          var ah;
          a7 = ah = (ag = a5[W]).start;
          a8 = ah + ag.count;
          for (; a7 < a8; a7 += 3) {
            z(G[a7 + 0]);
            z(G[a7 + 1]);
            z(G[a7 + 2]);
          }
        }
      } else {
        console.error(
          "THREE.BufferGeometryUtils: .computeTangents() failed. Missing required attributes (index, position, normal or uv)",
        );
      }
    },
    mergeBufferGeometries: function (j, k) {
      var q = j[0].index !== null;
      var z = new Set(Object.keys(j[0].attributes));
      var A = new Set(Object.keys(j[0].morphAttributes));
      var B = {};
      var C = {};
      var D = j[0].morphTargetsRelative;
      var E = new c.BufferGeometry();
      var F = 0;
      for (var G = 0; G < j.length; ++G) {
        var H = j[G];
        var I = 0;
        if (q !== (H.index !== null)) {
          console.error(
            "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " +
              G +
              ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.",
          );
          return null;
        }
        for (var J in H.attributes) {
          if (!z.has(J)) {
            console.error(
              "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " +
                G +
                '. All geometries must have compatible attributes; make sure "' +
                J +
                '" attribute exists among all geometries, or in none of them.',
            );
            return null;
          }
          if (B[J] === undefined) {
            B[J] = [];
          }
          B[J].push(H.attributes[J]);
          I++;
        }
        if (I !== z.size) {
          console.error(
            "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " +
              G +
              ". Make sure all geometries have the same number of attributes.",
          );
          return null;
        }
        if (D !== H.morphTargetsRelative) {
          console.error(
            "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " +
              G +
              ". .morphTargetsRelative must be consistent throughout all geometries.",
          );
          return null;
        }
        for (var J in H.morphAttributes) {
          if (!A.has(J)) {
            console.error(
              "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " +
                G +
                ".  .morphAttributes must be consistent throughout all geometries.",
            );
            return null;
          }
          if (C[J] === undefined) {
            C[J] = [];
          }
          C[J].push(H.morphAttributes[J]);
        }
        E.userData.mergedUserData = E.userData.mergedUserData || [];
        E.userData.mergedUserData.push(H.userData);
        if (k) {
          var K;
          if (q) {
            K = H.index.count;
          } else {
            if (H.attributes.position === undefined) {
              console.error(
                "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " +
                  G +
                  ". The geometry must have either an index or a position attribute",
              );
              return null;
            }
            K = H.attributes.position.count;
          }
          E.addGroup(F, K, G);
          F += K;
        }
      }
      if (q) {
        var L;
        var N = 0;
        var O = [];
        for (G = 0; G < j.length; ++G) {
          L = j[G].index;
          for (var P = 0; P < L.count; ++P) {
            O.push(L.getX(P) + N);
          }
          N += j[G].attributes.position.count;
        }
        E.setIndex(O);
      }
      for (var J in B) {
        var Q = this.mergeBufferAttributes(B[J]);
        if (!Q) {
          console.error(
            "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " +
              J +
              " attribute.",
          );
          return null;
        }
        E.setAttribute(J, Q);
      }
      for (var J in C) {
        var R = C[J][0].length;
        if (R === 0) {
          break;
        }
        E.morphAttributes = E.morphAttributes || {};
        E.morphAttributes[J] = [];
        var T;
        for (G = 0; G < R; ++G) {
          T = [];
          for (P = 0; P < C[J].length; ++P) {
            T.push(C[J][P][G]);
          }
          var U = this.mergeBufferAttributes(T);
          if (!U) {
            console.error(
              "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " +
                J +
                " morphAttribute.",
            );
            return null;
          }
          E.morphAttributes[J].push(U);
        }
      }
      return E;
    },
    mergeBufferAttributes: function (d) {
      var f;
      var g;
      var h;
      var j;
      var k = 0;
      for (var m = 0; m < d.length; ++m) {
        if ((j = d[m]).isInterleavedBufferAttribute) {
          console.error(
            "THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. InterleavedBufferAttributes are not supported.",
          );
          return null;
        }
        if (f === undefined) {
          f = j.array.constructor;
        }
        if (f !== j.array.constructor) {
          console.error(
            "THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.",
          );
          return null;
        }
        if (g === undefined) {
          g = j.itemSize;
        }
        if (g !== j.itemSize) {
          console.error(
            "THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.",
          );
          return null;
        }
        if (h === undefined) {
          h = j.normalized;
        }
        if (h !== j.normalized) {
          console.error(
            "THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.",
          );
          return null;
        }
        k += j.array.length;
      }
      var p = new f(k);
      var q = 0;
      for (m = 0; m < d.length; ++m) {
        p.set(d[m].array, q);
        q += d[m].array.length;
      }
      return new c.BufferAttribute(p, g, h);
    },
    interleaveAttributes: function (j) {
      var k;
      var q = 0;
      var v = 0;
      for (var w = 0, x = j.length; w < x; ++w) {
        F = j[w];
        if (k === undefined) {
          k = F.array.constructor;
        }
        if (k !== F.array.constructor) {
          console.error(
            "AttributeBuffers of different types cannot be interleaved",
          );
          return null;
        }
        q += F.array.length;
        v += F.itemSize;
      }
      var z = new c.InterleavedBuffer(new k(q), v);
      var A = 0;
      var B = [];
      var C = ["getX", "getY", "getZ", "getW"];
      var D = ["setX", "setY", "setZ", "setW"];
      var E = 0;
      for (x = j.length; E < x; E++) {
        var F;
        var G = (F = j[E]).itemSize;
        var H = F.count;
        var I = new c.InterleavedBufferAttribute(z, G, A, F.normalized);
        B.push(I);
        A += G;
        for (var J = 0; J < H; J++) {
          for (var K = 0; K < G; K++) {
            I[D[K]](J, F[C[K]](J));
          }
        }
      }
      return B;
    },
    estimateBytesUsed: function (d) {
      var f = 0;
      for (var g in d.attributes) {
        var h = d.getAttribute(g);
        f += h.count * h.itemSize * h.array.BYTES_PER_ELEMENT;
      }
      var j = d.getIndex();
      return (f += j ? j.count * j.itemSize * j.array.BYTES_PER_ELEMENT : 0);
    },
    mergeVertices: function (j, q = 0.0001) {
      q = Math.max(q, Number.EPSILON);
      var z = {};
      var B = j.getIndex();
      var F = j.getAttribute("position");
      var G = B ? B.count : F.count;
      var H = 0;
      var J = Object.keys(j.attributes);
      var K = {};
      var L = {};
      var N = [];
      var Q = ["getX", "getY", "getZ", "getW"];
      for (var U = 0, V = J.length; U < V; U++) {
        K[(a1 = J[U])] = [];
        if ((a6 = j.morphAttributes[a1])) {
          L[a1] = Array(a6.length)
            .fill()
            .map(() => []);
        }
      }
      var W = Math.log10(1 / q);
      var X = Math.pow(10, W);
      for (U = 0; U < G; U++) {
        var Y = B ? B.getX(U) : U;
        var Z = "";
        var a0 = 0;
        for (V = J.length; a0 < V; a0++) {
          var a1 = J[a0];
          for (
            var a2 = (a5 = j.getAttribute(a1)).itemSize, a3 = 0;
            a3 < a2;
            a3++
          ) {
            Z += ~~(a5[Q[a3]](Y) * X) + ",";
          }
        }
        if (Z in z) {
          N.push(z[Z]);
        } else {
          a0 = 0;
          V = J.length;
          for (; a0 < V; a0++) {
            a1 = J[a0];
            var a4;
            var a5 = j.getAttribute(a1);
            var a6 = j.morphAttributes[a1];
            a2 = a5.itemSize;
            var a7 = K[a1];
            var a8 = L[a1];
            for (a3 = 0; a3 < a2; a3++) {
              a4 = Q[a3];
              a7.push(a5[a4](Y));
              if (a6) {
                for (var a9 = 0, aa = a6.length; a9 < aa; a9++) {
                  a8[a9].push(a6[a9][a4](Y));
                }
              }
            }
          }
          z[Z] = H;
          N.push(H);
          H++;
        }
      }
      const ab = j.clone();
      U = 0;
      V = J.length;
      for (; U < V; U++) {
        a1 = J[U];
        var ac = j.getAttribute(a1);
        var ad = new ac.array.constructor(K[a1]);
        a5 = new c.BufferAttribute(ad, ac.itemSize, ac.normalized);
        ab.setAttribute(a1, a5);
        if (a1 in L) {
          for (a0 = 0; a0 < L[a1].length; a0++) {
            var ae = j.morphAttributes[a1][a0];
            ad = new ae.array.constructor(L[a1][a0]);
            var af = new c.BufferAttribute(ad, ae.itemSize, ae.normalized);
            ab.morphAttributes[a1][a0] = af;
          }
        }
      }
      ab.setIndex(N);
      return ab;
    },
    toTrianglesDrawMode: function (d, f) {
      if (f === c.TrianglesDrawMode) {
        console.warn(
          "THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.",
        );
        return d;
      }
      if (f === c.TriangleFanDrawMode || f === c.TriangleStripDrawMode) {
        var g = d.getIndex();
        if (g === null) {
          var h = [];
          var j = d.getAttribute("position");
          if (j === undefined) {
            console.error(
              "THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.",
            );
            return d;
          }
          for (var k = 0; k < j.count; k++) {
            h.push(k);
          }
          d.setIndex(h);
          g = d.getIndex();
        }
        var m = g.count - 2;
        var p = [];
        if (f === c.TriangleFanDrawMode) {
          for (k = 1; k <= m; k++) {
            p.push(g.getX(0));
            p.push(g.getX(k));
            p.push(g.getX(k + 1));
          }
        } else {
          for (k = 0; k < m; k++) {
            if (k % 2 == 0) {
              p.push(g.getX(k));
              p.push(g.getX(k + 1));
              p.push(g.getX(k + 2));
            } else {
              p.push(g.getX(k + 2));
              p.push(g.getX(k + 1));
              p.push(g.getX(k));
            }
          }
        }
        if (p.length / 3 != m) {
          console.error(
            "THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.",
          );
        }
        var q = d.clone();
        q.setIndex(p);
        q.clearGroups();
        return q;
      }
      console.error(
        "THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:",
        f,
      );
      return d;
    },
  };
};
